package com.sweetlime.bingeamigo.model

import kotlinx.serialization.Serializable

@Serializable
data class LibraryEpisode(
    val id: Int = 0,
    val watched: Boolean = false,
    val seasonNumber: Int = 0,
    val episodeNumber: Int = 0,
    val userRating: Double = 0.0,
    val userReview: String? = null
)
